"use client";

import { Facebook, Twitter, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted-dark-background animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted-dark-background animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted-dark-background animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted-dark-background animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex gap-6">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground-dark text-sm hover:underline underline-offset-4 transition-all duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <footer ref={ref} className={`bg-dark-background text-foreground-dark border-t border-border-strong py-8 px-4 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-sm">
          © {new Date().getFullYear()} LabExplain. All rights reserved.
        </div>

        <div className="flex gap-4">
          <Link to="https://facebook.com" newTab className="text-foreground-dark hover:text-primary transition-all duration-[var(--duration-medium)] hover:scale-110" aria-label="Facebook">
            <Facebook className="size-5" />
          </Link>
          <Link to="https://twitter.com" newTab className="text-foreground-dark hover:text-primary transition-all duration-[var(--duration-medium)] hover:scale-110" aria-label="Twitter">
            <Twitter className="size-5" />
          </Link>
          <Link to="https://instagram.com" newTab className="text-foreground-dark hover:text-primary transition-all duration-[var(--duration-medium)] hover:scale-110" aria-label="Instagram">
            <Instagram className="size-5" />
          </Link>
        </div>

        <MenuProvider menu_id="4">
          <FooterNavigation />
        </MenuProvider>
      </div>
    </footer>;
}